module.exports = __webpack_public_path__ + "static/img/5.5bd5666f.png";